import { Center } from '@astryxdesign/core/Center';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { Icon } from '@astryxdesign/core/Icon';
import { Compass } from '@phosphor-icons/react';

export function NotFoundView({ title, description = 'Проверьте ссылку или вернитесь на главную.' }: { title: string; description?: string }) {
  return (
    <Center height="70dvh">
      <EmptyState title={title} description={description} icon={<Icon icon={Compass} size="lg" />} headingLevel={1} />
    </Center>
  );
}
